<template>
    <div>  
        <div class="row">
            <div class="col col-12 col-md-6" v-for="(campo, index) in this.campos" :key="index">
                <div class="form-group" v-if="campo.type == 'select' && 1 == 0">
                    <label>{{ campo.display }}</label>
                    <select class="form-control" :id="campo.name" v-model="item[campo.name]">
                        <option></option>
                        <option v-for="(opt, idx) in options(campo)" :key="idx" :value="opt.data">
                            {{ opt.display }}
                        </option>
                    </select>
                </div>
                <az-input type="campo.type" :label="campo.display" v-model="item[campo.name]" v-else/>
            </div>
        </div>
    </div>
</template>

<script>
import AzInput from '../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            item: {}
        }
    },
    components: { 
        AzInput,
    },
    props: ['campos', 'registro', 'selectOptions', 'saveItem'],
    methods: { 
        options (campo) { 

            if ( !this.$props.selectOptions[campo.model] )
                return; 

            return this.$props.selectOptions[campo.model].data.map((item) => { 
                            return { "data": item[campo.option_data], "display": item[campo.option_display] };
                        });

        },
        salvar () { 
            this.saveItem(this.item);
        },
        buscarCep (cep) { 

            this.$store.commit('loading', true);

            let query = { 
							q: [ 
									{ 
										name: 'cep.show', 
										parms: { cep: cep }, 
										id: 'cep'
									}
								]
							};

            this.axios.post('aql', query)
                .then (res => { 
                    if ( res.data.cep.status == 200 ) { 
                        this.item.st_logradouro = res.data.cep.data.logradouro;
                        this.item.st_bairro = res.data.cep.data.bairro;
                    }
                })
                .finally (() => { 
                    this.$store.commit('loading', false);
                });

        }
    },
    mounted () {
        if ( this.$props.registro )
            this.item = this.$props.registro;
    }
}
</script>